export function bias(value: number) {
  const c = 0.501;
  const x = Math.abs(value);
  return Math.sign(value) * (x / ((1 / c - 2) * (1 - x) + 1));
}

export function calculateUpdatedOffset({
  selectedElement,
  containerSize,
  contentSize,
  currentScrollOffset,
  isHorizontal
}: {
  selectedElement: HTMLElement;
  containerSize: number;
  contentSize: number;
  currentScrollOffset: number;
  isHorizontal: boolean;
}): number {
  const clientSize = isHorizontal ? selectedElement.clientWidth : selectedElement.clientHeight;
  const offsetStart = isHorizontal ? selectedElement.offsetLeft : selectedElement.offsetTop;

  const totalSize = containerSize + currentScrollOffset;
  const itemOffset = clientSize + offsetStart;
  const additionalOffset = clientSize * 0.4;

  if (offsetStart <= currentScrollOffset) {
    currentScrollOffset = Math.max(offsetStart - additionalOffset, 0);
  } else if (totalSize <= itemOffset) {
    currentScrollOffset = Math.min(
      currentScrollOffset - (totalSize - itemOffset - additionalOffset),
      contentSize - containerSize
    );
  }

  return currentScrollOffset;
}

export function calculateCenteredOffset({
  selectedElement,
  containerSize,
  contentSize,
  isHorizontal
}: {
  selectedElement: HTMLElement;
  containerSize: number;
  contentSize: number;
  isHorizontal: boolean;
}): number {
  const clientSize = isHorizontal ? selectedElement.clientWidth : selectedElement.clientHeight;
  const offsetStart = isHorizontal ? selectedElement.offsetLeft : selectedElement.offsetTop;

  const offsetCentered = offsetStart + clientSize / 2 - containerSize / 2;

  return Math.min(contentSize - containerSize, Math.max(0, offsetCentered));
}
